/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconClose/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconClose({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconClose",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconClose.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-lYxEn': alignSelf,'--mt-2-lYxEn': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-lYxEn': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-lYxEn': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-lYxEn': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-lYxEn': opacity,'--w-10-lYxEn': typeof width === 'number' ? `${width}px` : width,'--h-11-lYxEn': typeof height === 'number' ? `${height}px` : height,'--a-7-lYxEn': isAnimated ? animation : "none",'--sd-8-lYxEn': isAnimated ? strokeDashoffset : 0,'--sd-9-lYxEn': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconClose.SvgPath"
  data-view-path={viewPath}
 d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
 style={{'--f-12-lYxEn': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}